(function (Translator) {
    // fr
    Translator.add("administration.user_search_button", "Chercher", "EvpAdministrationBundle", "fr");
    Translator.add("administration.user_search_label", "ID utilisateur", "EvpAdministrationBundle", "fr");
    Translator.add("forbidden", "Non autoris\u00e9", "EvpAdministrationBundle", "fr");
    Translator.add("internal_server_error", "Erreur de serveur", "EvpAdministrationBundle", "fr");
    Translator.add("invalid_code", "Code non valide", "EvpAdministrationBundle", "fr");
    Translator.add("invalid_grant", "Acc\u00e8s refus\u00e9", "EvpAdministrationBundle", "fr");
    Translator.add("invalid_parameters", "Param\u00e8tres non valides", "EvpAdministrationBundle", "fr");
    Translator.add("invalid_request", "Demande incorrecte", "EvpAdministrationBundle", "fr");
    Translator.add("invalid_state", "Statut non valide", "EvpAdministrationBundle", "fr");
    Translator.add("limits_exceeded", "Limite atteinte", "EvpAdministrationBundle", "fr");
    Translator.add("logout", "Se d\u00e9connecter", "EvpAdministrationBundle", "fr");
    Translator.add("not_acceptable", "Non accept\u00e9", "EvpAdministrationBundle", "fr");
    Translator.add("not_found", "Non trouv\u00e9", "EvpAdministrationBundle", "fr");
    Translator.add("pagination.first", "Premier", "EvpAdministrationBundle", "fr");
    Translator.add("pagination.last", "Dernier", "EvpAdministrationBundle", "fr");
    Translator.add("pagination.next", "Suivant", "EvpAdministrationBundle", "fr");
    Translator.add("pagination.page_out_of", "formulaire", "EvpAdministrationBundle", "fr");
    Translator.add("pagination.previous", "Retour", "EvpAdministrationBundle", "fr");
    Translator.add("rate_limit_exceeded", "Limite atteinte", "EvpAdministrationBundle", "fr");
    Translator.add("unauthorized", "Acc\u00e8s refus\u00e9", "EvpAdministrationBundle", "fr");
})(Translator);
